import { Backdrop, Box, Card, Grid, TextField, Typography, Switch } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { useFormik } from "formik";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import {
  getAllCargoUnits,
  getInventoryItemStatusListingAction,
  getWareHouseListingAction,
} from "src/app-redux/warehouse/actions/wareHouseActions";
import {
  loader,
  selectInventoryItemStatusListing,
  selectResetAddForm,
  selectWareHouseListing,
  resetAddForm,
} from "src/app-redux/warehouse/wareHouseSlice";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";
import { number, object, string } from "yup";
import CommonAutoCompleteField from "../../../../../../components/CommonAutoCompleteField/CommonAutoCompleteField";
import { useStyles } from "./styles";
import { disableCopy, disablePaste, validationNumber } from "src/common/utils/formValidation";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";
import { IAddInventoryItemNod } from "src/common/typings/nod-warehouse";
import CommonButton from "src/components/CommonButton/CommonButton";
import { ContainerDetail, vehicleDetail, indexDetail } from "src/common/typings/warehouse";
import CommonLoader from "src/components/Loader/CommonLoader";
import { getActiveAllContainerYardsListingAction } from "src/app-redux/yard/actions/yardActions";
import { selectAllYardsListing } from "src/app-redux/yard/yardSlice";

export interface IForm extends IAddInventoryItemNod {}

interface Props {
  containerDetail: (newContainer: ContainerDetail) => void;
  index_Detail: (newIndexDetail: indexDetail) => void;
  vehicleDetail: (newVehicleDetail: vehicleDetail) => void;
  inventory_Items: (item: IAddInventoryItemNod[]) => IAddInventoryItemNod[];
  itemToRemove: IAddInventoryItemNod | undefined;
  itemToEdit: IAddInventoryItemNod;
  isSaved?: boolean;
}
export function AddItemInputFields({
  containerDetail,
  index_Detail,
  vehicleDetail,
  inventory_Items,
  itemToRemove,
  itemToEdit,
  isSaved,
}: Props): React.ReactElement {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const validationSchema = object({
    detainedByName: string().when("isDetained", {
      is: () => {
        if (formik.values.isDetained == 1) {
          return true;
        }
      },
      then: string().required("This field is required.").max(50, "Maximum 50 characters allowed"),
      otherwise: string(),
    }),
    detainedByDesignation: string().when("isDetained", {
      is: () => {
        if (formik.values.isDetained == 1) {
          return true;
        }
      },
      then: string().required("This field is required.").max(50, "Maximum 50 characters allowed"),
      otherwise: string(),
    }),
    detainedByDepartment: string().when("isDetained", {
      is: () => {
        if (formik.values.isDetained == 1) {
          return true;
        }
      },
      then: string().required("This field is required.").max(50, "Maximum 50 characters allowed"),
      otherwise: string(),
    }),
    itemName: string().when("OtherItem", {
      is: () => {
        if (formik.values.OtherItem == 1) {
          return true;
        }
      },
      then: string().required("This field is required.").max(200, "Maximum 200 characters allowed"),
      otherwise: string(),
    }),
    //inventoryNameId: string().required("This field is required."),
    itemCode: string().max(50, "Maximum 50 characters allowed"),
    serialNumber: string().max(50, "Maximum 50 characters allowed"),
    isBannedItem: number().required("This field is required."),
    entryReason: string()
      .required("This field is required")
      .max(50, "Maximum 50 characters allowed"),
    warehouseId: string().required("This field is required"),
    cargoValue: number()
      .min(0, "Minimum should be zero")
      .max(10000000000, "Maximum 10 digits are allowed"),
    weight: number()
      .required("This field is required")
      .min(1, "Minimum 1 digits are allowed")
      .max(10000000000, "Maximum 10 digits are allowed"),
    dimensionLength: number()
      .min(0, "Minimum should be zero")
      .max(10000000000, "Maximum 10 digits are allowed"),
    dimensionWidth: number()
      .min(0, "Minimum should be zero")
      .max(10000000000, "Maximum 10 digits are allowed"),
    dimensionHeight: number()
      .min(0, "Minimum should be zero")
      .max(10000000000, "Maximum 10 digits are allowed"),
    statusId: string().required("This field is required."),
    remarks: string().max(3000, "Maximum 3000 characters allowed"),
    cargoType: string().required("This field is required"),
  });
  const formik = useFormik<IAddInventoryItemNod>({
    initialValues: {
      aisle: "",
      rack: "",
      shelf: "",
      bin: "",
      InventoryType: 0,
      isDetained: 0,
      detainedByName: "",
      detainedByDepartment: "",
      detainedByDesignation: "",
      supplierName: "",
      importerId: 0,
      importerPhoneNumber: "",
      exporterId: 0,
      exporterPhoneNumber: "",
      gatePassId: 0,
      isBannedItem: 0,
      inventoryNameId: "",
      name: "",
      modelNumber: "",
      serialNumber: "",
      warehouseId: "",
      entryDate: moment(new Date()).format("YYYY-MM-DDTHH:mm"),
      registrationNumber: "",
      itemCode: "",
      entryReason: "",
      remarks: "",
      weight: "",
      inspectionStatus: "",
      statusId: "",
      dimensionLength: "",
      dimensionWidth: "",
      dimensionHeight: "",
      cargoValue: "",
      weightUnit: "",
      dimensionUnit: "",
      currency: "PKR",
      driverName: "",
      containerNumber: "",
      indexNumber: 0,
      foundPackages: "",
      foundCBM: "",
      containerSize: "",
      isInvoiceFound: false,
      itemName: "",
      OtherItem: 0,
      otherUOM: "",
      yardId: 0,
      rowId: 0,
      slotId: 0,
      indexId: 0,
      cargoType: "",
      containerGatePassId: 0,
    },
    validationSchema: validationSchema,
    onSubmit: async () => {
      await addToGrid();
    },
  });
  const terminalType = Number(localStorage.getItem("terminalType"));
  const { height } = UseWindowDimensions();
  const minAccHeight = 50;
  let accordionMaxHeight = 0;
  accordionMaxHeight = height - minAccHeight;
  const [loader2, setLoader2] = useState(false);
  const loading = useAppSelector(loader);
  const wareHouseListing = useAppSelector(selectWareHouseListing);
  const inventoryItemStatusListing = useAppSelector(selectInventoryItemStatusListing);
  const [vehicleRegNumberArr, setvehicleRegNumberArr] = React.useState<any>([]);
  const [containerNumberArr, setContainerNumberArr] = React.useState<any>([]);
  const [indexList, seIndexList] = React.useState<any>([]);
  const allYards: any = useAppSelector(selectAllYardsListing);
  const [yardrows, setYardRows] = React.useState<any>([]);
  const [rowslots, setRowSlots] = React.useState<any>([]);
  const [IndexNumberArr, setIndexNumberArr] = React.useState<any>([]);
  const [inventoryItems, setInventoryItems] = React.useState<IAddInventoryItemNod[]>([]);
  const [vehicleNumberLength, setVehicleNumberLength] = useState<number>(0);
  const [cargoTypeData, setCargoTypeData] = React.useState<any>([]);
  const [allUnits, setAllUnits] = useState<any>([]);
  const inspectionStatusLinst = [
    { id: 1, name: "Passed" },
    { id: 0, name: "Failed" },
    { id: 2, name: "Detained" },
    { id: 3, name: "Other" },
  ];
  const InventoryTypeLinst = [
    { id: 0, name: "Cargo" },
    { id: 1, name: "Seized" },
    { id: 2, name: "Detained" },
    { id: 3, name: "Others" },
  ];
  const CargoTypeOptions = [
    { id: 1, status: "General" },
    { id: 2, status: "DG" },
  ];

  const getVehicleByRegistrationNo = async (queryString: string) => {
    let results: any = [];
    results = await fetchWrapper.get(
      `search-vehicles-by-vehicle-registration-number/${queryString}`
    );
    if (results.isSuccess) {
      setvehicleRegNumberArr(results.value);
    }
    return;
  };
  useEffect(() => {
    const fetchContainerNumbers = async () => {
      try {
        let results: any = [];
        results = await fetchWrapper.get("get-all-vehicles-and-containers-for-gate-out");
        if (results.isSuccess) {
          setContainerNumberArr(results.value.containerList);
        }
      } catch (error) {
        console.error("Error fetching container numbers:", error);
      }
    };

    fetchContainerNumbers();
  }, []);

  const getYardRows = async (id: number) => {
    let results: any = [];
    try {
      setLoader2(true);
      results = await fetchWrapper.get(`/get-yard-rows-by-yard-id/${id}?ShowIsActve=true`);
      if (results.isSuccess) {
        setYardRows(results.value);
      }
      setLoader2(false);
      return;
    } catch (error: any) {
      setLoader2(false);
    }
  };
  const getRowSlots = async (id: number) => {
    let results: any = [];
    try {
      setLoader2(true);
      results = await fetchWrapper.get(
        `/get-yard-row-slots-by-yard-row-id/${id}?showAvailableSlotsOnly=true&IsContainerYard=true`
      );
      if (results.isSuccess) {
        setRowSlots(results.value);
      }
      setLoader2(false);
      return;
    } catch (error: any) {
      setLoader2(false);
    }
  };

  const getContinerIndexes = async (continerNumber: string) => {
    let results: any = [];
    try {
      setLoader2(true);
      results = await fetchWrapper.get(`get-all-containers-indexes/${continerNumber}`);
      if (results.isSuccess) {
        setIndexNumberArr(results.value?.containerDetails);
        formik.setFieldValue("yardId", "");
        formik.setFieldValue("rowId", "");
        formik.setFieldValue("slotId", "");
        formik.setFieldValue("indexId", "");
        results.value?.yardDetails?.yardId && getYardRows(results.value?.yardDetails?.yardId);
        results.value?.yardDetails?.rowId && getRowSlots(results.value?.yardDetails?.rowId);
        results.value?.yardDetails?.slotId && getIndexList(results.value?.yardDetails?.slotId);
        formik.setFieldValue("yardId", results.value?.yardDetails?.yardId);
        formik.setFieldValue("rowId", results.value?.yardDetails?.rowId);
        formik.setFieldValue("slotId", results.value?.yardDetails?.slotId);
        formik.setFieldValue("indexId", results.value?.yardDetails?.indexId);
      }
      setLoader2(false);
      return;
    } catch (error: any) {
      setLoader2(false);
    }
  };

  const getVehicleDetail = async (id: number) => {
    let results: any = [];
    results = await fetchWrapper.get(`get-vehicle-status-id-by-vehicle-Id/${id}`);
    if (results.isSuccess == true) {
      vehicleDetail(results.value);
    }
  };

  useEffect(() => {
    setInventoryItems(inventoryItems.filter((item) => item !== itemToRemove));
  }, [itemToRemove]);

  useEffect(() => {
    const setFieldValues = async () => {
      formik.setValues(itemToEdit);
      setInventoryItems(inventoryItems.filter((item) => item !== itemToEdit));
    };
    setFieldValues();
  }, [itemToEdit]);

  const getVehicleDetailsByRegNo = async (id: number, title: string) => {
    let results: any = [];
    try {
      setLoader2(true);
      results = await fetchWrapper.get(`get-vehicle-driver-detail-by-vehicle-reg-numb/${title}`);
      if (results.isSuccess == true) {
        formik.setFieldValue("registrationNumber", title);
        const resultObj = results.value.vehicleDriverDetail;
        getVehicleDetail(id);
        formik.setFieldValue("gatePassId", resultObj.gatePassId);
        formik.setFieldValue("driverName", resultObj.driverName);
      }
      setLoader2(false);
      return;
    } catch (error: any) {
      setLoader2(false);
    }
  };
  useEffect(() => {
    dispatch(getWareHouseListingAction());
    dispatch(getInventoryItemStatusListingAction());
  }, []);

  const counterResetAddForm = useAppSelector(selectResetAddForm);

  useEffect(() => {
    if (counterResetAddForm) formik.resetForm();
  }, [counterResetAddForm]);

  const getVehicleConfiguration = async () => {
    try {
      const results = await fetchWrapper.get("get-all-vehicle-configuration");
      if (results.isSuccess === true) {
        setCargoTypeData(results.value);
        return;
      }
    } catch (error: any) {}
  };
  useEffect(() => {
    getVehicleConfiguration();
    getListing();
    getAllUnits();
    dispatch(getActiveAllContainerYardsListingAction());
  }, []);

  const scrollContainerRef: any = useRef(null);
  const datePickerRef: any = useRef(null);
  useEffect(() => {
    const handleScroll = () => {
      datePickerRef?.current?.flatpickr?.close();
    };
    scrollContainerRef?.current?.addEventListener("scroll", handleScroll);
    return () => {
      scrollContainerRef?.current?.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [supplierTypeList, setSupplierTypeList] = useState([]);

  const getListing = async () => {
    let results: any = [];
    try {
      results = await fetchWrapper.get(`get_all-supplier-details?getActiveSuppliersOnly=${true}`);
      if (results.isSuccess == true) {
        setSupplierTypeList(results.value);
      }
      return;
    } catch (error: any) {
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
  };

  const getAllUnits = async () => {
    const res = await dispatch(getAllCargoUnits());
    setAllUnits(res.payload || []);
  };

  const addToGrid = () => {
    formik.values.inspectionStatus === ""
      ? (formik.values.inspectionStatus = "0")
      : formik.values.inspectionStatus;
    setInventoryItems((prevItems) => [...prevItems, { ...formik.values }]);
    dispatch(resetAddForm());
  };

  useEffect(() => {
    inventory_Items(inventoryItems);
  }, [inventoryItems]);

  useEffect(() => {
    dispatch(resetAddForm());
    setInventoryItems([]);
  }, [isSaved]);

  const supplierNameHandler = async (id: any) => {
    formik.setFieldValue("supplierName", id);
    const supplier: any = await supplierTypeList.find((st: any) => st.id === id);
    if (supplier.supplierType == "Importer") {
      formik.setFieldValue("importerId", id);
      formik.setFieldValue("exporterId", 0);
    } else if (supplier.supplierType == "Exporter") {
      formik.setFieldValue("exporterId", id);
      formik.setFieldValue("importerId", 0);
    } else {
      formik.setFieldValue("importerId", 0);
      formik.setFieldValue("exporterId", 0);
    }
  };

  const getIndexList = async (id: any) => {
    const results = await fetchWrapper.get(
      `get-yard-index-details-by-column-id/${id}?ShowAvailableSlotsOnly=true`
    );
    if (results.isSuccess) {
      seIndexList(results.value);
    }
    return;
  };

  return (
    <>
      <form>
        <Backdrop className={classes.backdrop} open={loading || loader2}>
          <CommonLoader />
        </Backdrop>
        <Grid container direction="row" alignItems="flex-start">
          <>
            <Grid
              item
              md={12}
              component={Card}
              className={classes.tabCardContent}
              ref={scrollContainerRef}
              style={{ height: accordionMaxHeight }}
            >
              <Grid className={classes.UserMainPanel}>
                <Grid container direction="row" alignItems="center" spacing={2}>
                  {/* Vehicle Driver Details */}
                  <Grid
                    item
                    md={12}
                    className={classes.sectionHeading}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography>Item Details </Typography>
                    <Box textAlign="right" mt={1}>
                      <CommonButton
                        cssClass="customSubmitBtn"
                        onClick={() => {
                          // dispatch(resetAddForm());
                          formik.resetForm();
                        }}
                      >
                        Reset
                      </CommonButton>
                      <CommonButton
                        cssClass="customSubmitBtn"
                        isGreen
                        onClick={() => formik.submitForm()}
                      >
                        Add
                      </CommonButton>
                    </Box>
                  </Grid>
                  <>
                    <Grid item xs={12} md={4}>
                      <Box>
                        <CommonAutoCompleteField
                          required
                          cssClassName="customTextField"
                          error={
                            formik.touched.InventoryType && Boolean(formik.errors.InventoryType)
                          }
                          helperText={formik.touched.InventoryType && formik.errors.InventoryType}
                          label="Inventory Type"
                          placeholder="Select Inventory Type"
                          name="InventoryType"
                          optionsType={InventoryTypeLinst}
                          getOptionLabel={(option: any) => option.name || ""}
                          value={
                            InventoryTypeLinst.find(
                              (st: any) => st.id === formik.values.InventoryType
                            ) || null
                          }
                          onChange={(option: any) => {
                            if (option && option.id >= 0) {
                              formik.setFieldValue("InventoryType", option.id);
                              formik.setFieldValue("inventoryNameId", "");
                              formik.setFieldValue("name", "");
                              formik.setFieldValue("weightUnit", "");
                              formik.setFieldValue("dimensionUnit", "");
                              if (option.id == 2) {
                                formik.setFieldValue("isDetained", 1);
                                formik.setFieldValue("isBannedItem", 0);
                                formik.setFieldValue("OtherItem", 0);
                              } else if (option.id == 1) {
                                formik.setFieldValue("isDetained", 0);
                                formik.setFieldValue("isBannedItem", 1);
                                formik.setFieldValue("OtherItem", 0);
                              } else if (option.id == 0) {
                                formik.setFieldValue("isDetained", 0);
                                formik.setFieldValue("isBannedItem", 0);
                                formik.setFieldValue("OtherItem", 0);
                              } else {
                                formik.setFieldValue("OtherItem", 1);
                                formik.setFieldValue("isDetained", 0);
                                formik.setFieldValue("isBannedItem", 0);
                              }
                            }
                          }}
                        />
                      </Box>
                    </Grid>
                    {formik.values.OtherItem == 0 && (
                      <Grid item xs={12} md={4}>
                        <Box>
                          <CommonAutoCompleteField
                            cssClassName="customTextField"
                            label="Item Name"
                            name="inventoryNameId"
                            optionsType={
                              formik.values.InventoryType == 0
                                ? cargoTypeData.cargoTypeData
                                : formik.values.InventoryType == 1
                                ? cargoTypeData.bannedItemData
                                : formik.values.InventoryType == 2
                                ? [...cargoTypeData.cargoTypeData, ...cargoTypeData.bannedItemData]
                                : []
                            }
                            placeholder="Select Item Name"
                            required
                            getOptionLabel={(option: any) => option.name || ""}
                            value={
                              formik.values.isBannedItem == 0
                                ? cargoTypeData?.cargoTypeData?.find(
                                    (st: any) => st.id === formik.values.inventoryNameId
                                  ) || null
                                : cargoTypeData?.bannedItemData?.find(
                                    (st: any) => st.id === formik.values.inventoryNameId
                                  ) || null
                            }
                            onChange={(option: any) => {
                              if (option && option.id !== 0) {
                                formik.setFieldValue("inventoryNameId", option.id);
                                formik.setFieldValue("name", option.name);
                                formik.setFieldValue("weightUnit", option.unitId);
                                formik.setFieldValue("dimensionUnit", option.unitId);
                                if (option.isBannedItem) {
                                  formik.setFieldValue("isBannedItem", 1);
                                } else {
                                  formik.setFieldValue("isBannedItem", 0);
                                }

                                // handleValueChange({ target: { value: option.name } });
                              }
                            }}
                            error={
                              formik.touched.inventoryNameId &&
                              Boolean(formik.errors.inventoryNameId)
                            }
                            helperText={
                              formik.touched.inventoryNameId && formik.errors.inventoryNameId
                            }
                          />
                        </Box>
                      </Grid>
                    )}
                    {formik.values.isDetained == 1 && (
                      <>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              className={"customTextField"}
                              required={formik.values.isDetained == 1}
                              size="small"
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Name"
                              name="detainedByName"
                              placeholder="Enter Name"
                              disabled={false}
                              value={formik.values.detainedByName}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.detainedByName &&
                                Boolean(formik.errors.detainedByName)
                              }
                              helperText={
                                formik.touched.detainedByName && formik.errors.detainedByName
                              }
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              className={"customTextField"}
                              required={formik.values.isDetained == 1}
                              size="small"
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Department"
                              name="detainedByDepartment"
                              placeholder="Enter Department"
                              disabled={false}
                              value={formik.values.detainedByDepartment}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.detainedByDepartment &&
                                Boolean(formik.errors.detainedByDepartment)
                              }
                              helperText={
                                formik.touched.detainedByDepartment &&
                                formik.errors.detainedByDepartment
                              }
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              className={"customTextField"}
                              required={formik.values.isDetained == 1}
                              size="small"
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Designation"
                              name="detainedByDesignation"
                              placeholder="Enter Designation"
                              disabled={false}
                              value={formik.values.detainedByDesignation}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.detainedByDesignation &&
                                Boolean(formik.errors.detainedByDesignation)
                              }
                              helperText={
                                formik.touched.detainedByDesignation &&
                                formik.errors.detainedByDesignation
                              }
                            />
                          </Box>
                        </Grid>
                      </>
                    )}
                    {formik.values.OtherItem == 1 && (
                      <Grid item xs={12} md={4} lg={4}>
                        <Box>
                          <TextField
                            className={"customTextField"}
                            size="small"
                            fullWidth
                            required
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            label="Item Name"
                            name="itemName"
                            placeholder="Enter Item Name"
                            value={formik.values.itemName}
                            onChange={formik.handleChange}
                            error={formik.touched.itemName && Boolean(formik.errors.itemName)}
                            helperText={formik.touched.itemName && formik.errors.itemName}
                          />
                        </Box>
                      </Grid>
                    )}
                    <Grid item xs={12} md={4} lg={4}>
                      <Box>
                        <TextField
                          className={"customTextField"}
                          size="small"
                          fullWidth
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Item Code"
                          name="itemCode"
                          placeholder="Enter Item Code"
                          disabled={false}
                          value={formik.values.itemCode}
                          onChange={formik.handleChange}
                          error={formik.touched.itemCode && Boolean(formik.errors.itemCode)}
                          helperText={formik.touched.itemCode && formik.errors.itemCode}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4} lg={4}>
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          label="Cargo Type"
                          placeholder="Select Cargo Type"
                          name="cargoType"
                          optionsType={CargoTypeOptions}
                          required
                          getOptionLabel={(option) => option.status || ""}
                          value={
                            CargoTypeOptions.find(
                              (opt) => opt.status === formik.values.cargoType
                            ) || null
                          }
                          onChange={(option) => {
                            option && option.status
                              ? formik.setFieldValue("cargoType", option.status)
                              : "";
                          }}
                          error={formik.touched.cargoType && Boolean(formik.errors.cargoType)}
                          helperText={formik.touched.cargoType && formik.errors.cargoType}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Box>
                        <TextField
                          className={"customTextField"}
                          required
                          size="small"
                          fullWidth
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Reason for Entry"
                          name="entryReason"
                          placeholder="Enter Reason for Entry"
                          disabled={false}
                          value={formik.values.entryReason}
                          onChange={formik.handleChange}
                          error={formik.touched.entryReason && Boolean(formik.errors.entryReason)}
                          helperText={formik.touched.entryReason && formik.errors.entryReason}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          error={formik.touched.warehouseId && Boolean(formik.errors.warehouseId)}
                          helperText={formik.touched.warehouseId && formik.errors.warehouseId}
                          label="Warehouse"
                          placeholder="Select Warehouse"
                          name="warehouseId"
                          optionsType={wareHouseListing}
                          required
                          getOptionLabel={(option: any) => option.name || ""}
                          value={
                            wareHouseListing.find(
                              (st: any) => st.id === formik.values.warehouseId
                            ) || null
                          }
                          onChange={(option: any) => {
                            option && option.id !== 0
                              ? formik.setFieldValue("warehouseId", option.id)
                              : "";
                          }}
                        />
                      </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          label="Item Status"
                          placeholder="Select Item Status"
                          name="statusId"
                          optionsType={inventoryItemStatusListing}
                          required
                          getOptionLabel={(option: any) => option.status || ""}
                          value={
                            inventoryItemStatusListing.find(
                              (st: any) => st.id === formik.values.statusId
                            ) || null
                          }
                          onChange={(option: any) => {
                            option && option.id !== 0
                              ? formik.setFieldValue("statusId", option.id)
                              : "";
                          }}
                          error={formik.touched.statusId && Boolean(formik.errors.statusId)}
                          helperText={formik.touched.statusId && formik.errors.statusId}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          error={
                            formik.touched.inspectionStatus &&
                            Boolean(formik.errors.inspectionStatus)
                          }
                          helperText={
                            formik.touched.inspectionStatus && formik.errors.inspectionStatus
                          }
                          label="Inspection Status"
                          placeholder="Select Inspection Status"
                          name="InspectionStatus"
                          optionsType={inspectionStatusLinst}
                          getOptionLabel={(option: any) => option.name || ""}
                          value={
                            inspectionStatusLinst.find(
                              (st: any) => st.id === formik.values.inspectionStatus
                            ) || null
                          }
                          onChange={(option: any) => {
                            formik.setFieldValue("inspectionStatus", option.id);
                          }}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Box>
                        <TextField
                          className={"customTextField"}
                          size="small"
                          fullWidth
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Found Packages"
                          name="foundPackages"
                          placeholder="Enter Found Packages"
                          disabled={false}
                          value={formik.values.foundPackages}
                          onChange={formik.handleChange}
                          // error={formik.touched.foundPackages}
                          // helperText={formik.touched.foundPackages && formik.errors.foundPackages}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Box>
                        <TextField
                          className={"customTextField"}
                          size="small"
                          fullWidth
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Found CBM"
                          name="foundCBM"
                          placeholder="Enter found cbm"
                          disabled={false}
                          value={formik.values.foundCBM}
                          onChange={formik.handleChange}
                          error={formik.touched.foundCBM && Boolean(formik.errors.foundCBM)}
                          helperText={formik.touched.foundCBM && formik.errors.foundCBM}
                        />
                      </Box>
                    </Grid>
                  </>
                  <Grid item md={12} className={classes.sectionHeading}>
                    <Typography>Item Specifications</Typography>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Box>
                      <TextField
                        required
                        className={"customTextField"}
                        type="number"
                        InputProps={{ inputProps: { min: 0 } }}
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Quantity"
                        name="weight"
                        placeholder="Enter Quantity"
                        value={formik.values.weight}
                        onChange={formik.handleChange}
                        error={formik.touched.weight && Boolean(formik.errors.weight)}
                        helperText={formik.touched.weight && formik.errors.weight}
                        onBlur={() => {
                          const num = parseFloat(formik.values.weight || "0");
                          const cleanNum = num.toFixed(2);
                          formik.setFieldValue("weight", cleanNum);
                        }}
                        onKeyDown={(evt) => validationNumber(evt)}
                        onCopy={disableCopy}
                        onPaste={disablePaste}
                        onCut={disableCopy}
                      />
                    </Box>
                  </Grid>
                  {formik.values.OtherItem == 0 && (
                    <Grid item xs={12} md={4}>
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          error={formik.touched.weightUnit && Boolean(formik.errors.weightUnit)}
                          helperText={formik.touched.weightUnit && formik.errors.weightUnit}
                          label="UOM"
                          placeholder="UOM"
                          name="weightUnit"
                          //required
                          optionsType={allUnits}
                          getOptionLabel={(option) =>
                            option.unit == "Cubic meter" ? "m³" : option.unit
                          }
                          value={
                            allUnits.find(({ id }: any) => id === formik.values.weightUnit) || null
                          }
                          disabled={true}
                        />
                      </Box>
                    </Grid>
                  )}
                  {formik.values.OtherItem == 1 && (
                    <Grid item xs={12} md={4} lg={4}>
                      <Box>
                        <TextField
                          className={"customTextField"}
                          size="small"
                          fullWidth
                          required
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="UOM"
                          name="otherUOM"
                          placeholder="Enter Unit Of Measure"
                          value={formik.values.otherUOM}
                          onChange={formik.handleChange}
                          error={formik.touched.otherUOM && Boolean(formik.errors.otherUOM)}
                          helperText={formik.touched.otherUOM && formik.errors.otherUOM}
                        />
                      </Box>
                    </Grid>
                  )}
                  <Grid item xs={12} md={4} lg={4}>
                    <CommonTextFieldDate
                      outerCss={true}
                      cssClassName={`${classes.dateTime} ${"customTextField"}`}
                      label={"Entry Date and Time"}
                      name={"dateTime"}
                      datePickerRef={datePickerRef}
                      value={formik.values.entryDate}
                      required={true}
                      onChange={(e: any) => {
                        formik.setFieldValue("entryDate", e);
                      }}
                      maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                      error={formik.touched.entryDate && Boolean(formik.errors.entryDate)}
                      helperText={formik.touched.entryDate && formik.errors.entryDate}
                    />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Box>
                      <TextField
                        className={"customTextField"}
                        multiline
                        rows={2}
                        rowsMax={8}
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Remarks"
                        name="remarks"
                        placeholder="Enter Remarks"
                        disabled={false}
                        value={formik.values.remarks}
                        onChange={formik.handleChange}
                        error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                        helperText={formik.touched.remarks && formik.errors.remarks}
                      />
                    </Box>
                  </Grid>
                  <Grid item md={12} className={classes.sectionHeading}>
                    <Typography>Container/Vehicle Details</Typography>
                  </Grid>
                  <>
                    <Grid item xs={12} md={4}>
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          label="Vehicle Number"
                          placeholder="Select Vehicle Number"
                          name="registrationNumber"
                          optionsType={vehicleRegNumberArr}
                          getOptionLabel={(option) => option.registrationNumber}
                          // required
                          value={
                            vehicleRegNumberArr.find(
                              (st: any) =>
                                st.registrationNumber === formik.values.registrationNumber
                            ) || null
                          }
                          onChange={(option: any) => {
                            option && option.registrationNumber !== "" && option.vehicleId !== 0
                              ? getVehicleDetailsByRegNo(
                                  option.vehicleId,
                                  option.registrationNumber
                                )
                              : formik.setFieldValue("registrationNumber", "");
                          }}
                          onKeyUp={(e: any) => {
                            setVehicleNumberLength(e.target.value.length);

                            if (e.target.value.length == 2 && vehicleNumberLength < 2) {
                              getVehicleByRegistrationNo(e.target.value);
                              return;
                            }
                          }}
                          onKeyDownCapture={(e: any) => {
                            if (/[^A-Za-z0-9\d]/.test(e.key)) e.preventDefault();
                          }}
                          onPaste={(e: any) => {
                            if (/[^A-Za-z0-9\d]/.test(e.clipboardData.getData("text"))) {
                              e.preventDefault();
                              return;
                            }

                            if (e.clipboardData.getData("text").length >= 2)
                              getVehicleByRegistrationNo(e.clipboardData.getData("text"));
                          }}
                          error={
                            formik.touched.registrationNumber &&
                            Boolean(formik.errors.registrationNumber)
                          }
                          helperText={
                            formik.touched.registrationNumber && formik.errors.registrationNumber
                          }
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          label="Container Number"
                          placeholder="Select Container"
                          name="containerNumber"
                          optionsType={containerNumberArr}
                          getOptionLabel={(option) => option.containerNumber}
                          value={
                            containerNumberArr.find(
                              (st: any) => st.containerNumber === formik.values.containerNumber
                            ) || null
                          }
                          onChange={(option: any) => {
                            if (option && option.containerNumber) {
                              containerDetail(option);
                              getContinerIndexes(option.containerNumber);
                              setIndexNumberArr([]);
                              formik.setFieldValue("indexNumber", 0);
                              formik.setFieldValue("containerNumber", option.containerNumber);
                              formik.setFieldValue("gatePassId", option.gateEntryId);
                              formik.setFieldValue("containerGatePassId", option?.gateEntryId);
                            } else {
                              formik.setFieldValue("containerNumber", "");
                              formik.setFieldValue("continerSize", "");
                            }
                          }}
                        />
                      </Box>
                    </Grid>
                    {/* <Grid item xs={12} md={4}>
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          label="Index Number"
                          placeholder="Select Index"
                          name="indexNumber"
                          optionsType={IndexNumberArr}
                          getOptionLabel={(option) => option.indexNumber.toString()}
                          value={
                            IndexNumberArr?.find(
                              (st: any) => st.indexNumber == formik.values.indexNumber
                            ) || null
                          }
                          onChange={(option: any) => {
                            if (option && option.indexNumber) {
                              index_Detail(option);
                              formik.setFieldValue("indexNumber", option?.indexNumber);
                            } else {
                              formik.setFieldValue("indexNumber", 0);
                            }
                          }}
                        />
                      </Box>
                    </Grid> */}
                    <Grid item xs={12} md={4}>
                      <Box>
                        {terminalType === 4 ? (
                          // Manual Input when terminalType is 4
                          <TextField
                            className="customTextField"
                            fullWidth
                            size="small"
                            variant="outlined"
                            label="Index Number"
                            name="indexNumber"
                            placeholder="Enter Index Number"
                            InputLabelProps={{ shrink: true }}
                            value={formik.values.indexNumber}
                            onChange={formik.handleChange}
                            required
                            error={formik.touched.indexNumber && Boolean(formik.errors.indexNumber)}
                            helperText={formik.touched.indexNumber && formik.errors.indexNumber}
                            // disabled={initialValues?.gateEntryId}
                          />
                        ) : (
                          // Dropdown Input for other terminal types
                          <CommonAutoCompleteField
                            cssClassName="customTextField"
                            label="Index Number"
                            placeholder="Select Index"
                            name="indexNumber"
                            optionsType={IndexNumberArr}
                            getOptionLabel={(option) => option.indexNumber.toString()}
                            value={
                              IndexNumberArr?.find(
                                (st: any) => st.indexNumber == formik.values.indexNumber
                              ) || null
                            }
                            onChange={(option: any) => {
                              if (option && option.indexNumber) {
                                index_Detail(option);
                                formik.setFieldValue("indexNumber", option?.indexNumber);
                              } else {
                                formik.setFieldValue("indexNumber", 0);
                              }
                            }}
                          />
                        )}
                      </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          label="Importer/ Exporter Name"
                          placeholder="Select Importer/Exporter Name"
                          name="supplierName"
                          optionsType={supplierTypeList}
                          getOptionLabel={(option: any) =>
                            option.supplierName && option.supplierType
                              ? `${option.supplierType} - ${option.supplierName}`
                              : option.supplierName
                              ? option.supplierName
                              : ""
                          }
                          renderOption={(option) => (
                            <span>
                              {option.supplierName && option.supplierType
                                ? `${option.supplierType} - ${option.supplierName}`
                                : option.supplierName
                                ? option.supplierName
                                : ""}
                            </span>
                          )}
                          //required
                          value={
                            supplierTypeList.find(
                              (st: any) => st.id === formik.values.supplierName
                            ) || null
                          }
                          onChange={(option: any) => {
                            option && option !== "" ? supplierNameHandler(option.id) : "";
                          }}
                          error={formik.touched.supplierName && Boolean(formik.errors.supplierName)}
                          helperText={formik.touched.supplierName && formik.errors.supplierName}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Box>
                        <TextField
                          className="customTextField"
                          size="small"
                          fullWidth
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Driver Name"
                          name="driverName"
                          placeholder="Driver Name"
                          disabled={true}
                          value={formik.values.driverName}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4} lg={3} style={{ paddingRight: 0 }}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={Boolean(formik.values.isInvoiceFound)}
                            onChange={formik.handleChange}
                            name="isInvoiceFound"
                            color="primary"
                          />
                        }
                        label="Is Invoice Found"
                      />
                    </Grid>
                  </>
                  <Grid item md={12} className={classes.sectionHeading}>
                    <Typography>Location</Typography>
                  </Grid>
                  <>
                    <Grid item xs={12} md={4}>
                      <Box>
                        <TextField
                          className={"customTextField"}
                          size="small"
                          fullWidth
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Aisle"
                          name="aisle"
                          placeholder="Enter Aisle"
                          disabled={false}
                          value={formik.values.aisle}
                          onChange={formik.handleChange}
                          error={formik.touched.aisle && Boolean(formik.errors.aisle)}
                          helperText={formik.touched.aisle && formik.errors.aisle}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Box>
                        <TextField
                          className={"customTextField"}
                          size="small"
                          fullWidth
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Rack"
                          name="rack"
                          placeholder="Enter Rack"
                          disabled={false}
                          value={formik.values.rack}
                          onChange={formik.handleChange}
                          error={formik.touched.rack && Boolean(formik.errors.rack)}
                          helperText={formik.touched.rack && formik.errors.rack}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Box>
                        <TextField
                          className={"customTextField"}
                          size="small"
                          fullWidth
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Shelf"
                          name="shelf"
                          placeholder="Enter Shelf"
                          disabled={false}
                          value={formik.values.shelf}
                          onChange={formik.handleChange}
                          error={formik.touched.shelf && Boolean(formik.errors.shelf)}
                          helperText={formik.touched.shelf && formik.errors.shelf}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Box>
                        <TextField
                          className={"customTextField"}
                          size="small"
                          fullWidth
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Bin"
                          name="bin"
                          placeholder="Enter Bin"
                          disabled={false}
                          value={formik.values.bin}
                          onChange={formik.handleChange}
                          error={formik.touched.bin && Boolean(formik.errors.bin)}
                          helperText={formik.touched.bin && formik.errors.bin}
                        />
                      </Box>
                    </Grid>
                  </>
                  <Grid item md={12} className={classes.sectionHeading}>
                    <Typography>Yard Details</Typography>
                  </Grid>
                  <>
                    <Grid item xs={12} md={4}>
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          label="Yard Name"
                          placeholder="Yard Name"
                          name="yardId"
                          disableClearable={true}
                          disabled={!formik.values.containerNumber}
                          optionsType={allYards}
                          getOptionLabel={(option) => option.name.toString()}
                          value={allYards.find((st: any) => st.id === formik.values.yardId) || null}
                          onChange={(option: any) => {
                            if (option && option.id !== 0) {
                              getYardRows(option.id);
                              formik.setFieldValue("yardId", option.id);
                              formik.setFieldValue("rowId", "");
                              formik.setFieldValue("slotId", "");
                              formik.setFieldValue("indexId", "");
                              seIndexList([]);
                            }
                          }}
                          error={formik.touched.yardId && Boolean(formik.errors.yardId)}
                          helperText={formik.touched.yardId && formik.errors.yardId}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          error={formik.touched.rowId && Boolean(formik.errors.rowId)}
                          helperText={formik.touched.rowId && formik.errors.rowId}
                          label="Yard Row"
                          placeholder="Select Yard Row"
                          name="rowId"
                          disableClearable={true}
                          disabled={!formik.values.containerNumber}
                          optionsType={yardrows}
                          getOptionLabel={(option: any) => option.rowName || ""}
                          value={
                            yardrows.find((st: any) => st?.yardRowId == formik.values.rowId) || null
                          }
                          onChange={(option: any) => {
                            if (option && option.yardRowId !== 0) {
                              getRowSlots(option.yardRowId);
                              formik.setFieldValue("rowId", option.yardRowId);
                              formik.setFieldValue("slotId", "");
                              formik.setFieldValue("indexId", "");
                              seIndexList([]);
                            }
                          }}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          error={formik.touched.slotId && Boolean(formik.errors.slotId)}
                          helperText={formik.touched.slotId && formik.errors.slotId}
                          label="Yard Slot"
                          placeholder="Yard Slot"
                          name="slotId"
                          disableClearable={true}
                          disabled={!formik.values.containerNumber}
                          optionsType={rowslots}
                          getOptionLabel={(option: any) => option.columnOrder.toString() || ""}
                          value={rowslots.find((st: any) => st.id == formik.values.slotId) || null}
                          onChange={(option: any) => {
                            formik.setFieldValue("slotId", option.id);
                            formik.setFieldValue("indexId", "");
                            seIndexList([]);
                            getIndexList(option.id);
                          }}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          error={formik.touched.indexId && Boolean(formik.errors.indexId)}
                          helperText={formik.touched.indexId && formik.errors.indexId}
                          label="Yard Index"
                          placeholder="Yard Index"
                          name="indexOrder"
                          disableClearable={true}
                          disabled={!formik.values.containerNumber}
                          optionsType={indexList}
                          getOptionLabel={(option: any) =>
                            option.indexOrder?.toString() || "" || ""
                          }
                          value={
                            indexList.find((st: any) => st.id === formik.values.indexId) || null
                          }
                          onChange={(option: any) => {
                            option && option.id !== 0
                              ? formik.setFieldValue("indexId", option.id)
                              : "";
                          }}
                        />
                      </Box>
                    </Grid>
                  </>
                </Grid>
              </Grid>
            </Grid>
          </>
        </Grid>
      </form>
      {/* <div>
        <CommonMaterialGrid
          defaultPerPageRecord={dppr}
          height={gridMaxHeight}
          loader={loading}
          rows={allUsers?.filter((data) => data.isActive === isActiveUser) || []}
          columns={displayColumns}
        />
      </div> */}
    </>
  );
}
